import { useEffect, useState } from 'react'
import { ExecutionState, Node } from 'workflow/shared/types/workflow.type'
import { useFetchYesObjects } from 'yesObject/shared'

type useTasksByProcessProps = {
  processUuid?: string
  taskmodelUuid?: string
}

export default function useTasksByProcess({
  processUuid = '',
  taskmodelUuid = ''
}: useTasksByProcessProps) {
  const [tasks, setTasks] = useState<Node[]>()

  const { yesObjects: processTokens } = useFetchYesObjects({
    initialPagination: {},
    filterBody: {
      query: {
        $and: [
          {
            'situation.des': {
              $gte: window.activeSituationCode
            },
            'process.uuid': {
              $in: [processUuid as string]
            }
          }
        ]
      },
      objectclass: window.uuidObjectclassProcess,
      skip_relations: false,
      skip_metadata: true
    },
    shouldMergeFilters: true,
    enabled: !!processUuid
  })

  const { yesObjects: filteredTasks } = useFetchYesObjects({
    initialPagination: {},
    filterBody: {
      query: {
        $and: [
          {
            'situation.des': {
              $gte: window.activeSituationCode
            },
            'uuid_Taskmodel.des': {
              $eq: taskmodelUuid
            },
            'uuid.des': {
              $in: tasks?.map((task) => task.uuid) ?? []
            }
          }
        ]
      },
      objectclass: window.taskObjectclassUuid,
      skip_relations: false,
      skip_metadata: true
    },
    shouldMergeFilters: true,
    enabled: !!taskmodelUuid
  })

  useEffect(() => {
    if (processTokens.length == 0) return

    const executionStates: Array<ExecutionState> = processTokens.map(
      (processToken) =>
        processToken.execution_state
          ? JSON.parse(processToken.execution_state as string)
          : {}
    )

    const nodemodels = Object.fromEntries(
      executionStates[0].flow_elementmodels.nodemodels.map((nodemodel) => [
        nodemodel.uuid,
        nodemodel
      ])
    )

    const nodes = executionStates.flatMap((state) => state.nodes)

    const tasks = nodes.filter(
      (node) =>
        nodemodels?.[node.nodemodel_uuid]?.type ===
          'interaction_task_nodemodel' ||
        nodemodels?.[node.nodemodel_uuid]?.type === 'output_task_nodemodel'
    )

    setTasks(tasks)
  }, [processTokens])

  return { tasks: taskmodelUuid ? filteredTasks : tasks }
}
